import { complement } from 'ramda';
import moment from 'moment';
import { hasChannel } from './consent-utils';
export function getPastPaymentDate(payment) {
  return payment.getIn(['activity', 'modifiedAt'], payment.get('modifiedAt'));
}
function getUpcomingPaymentDate(payment) {
  return payment.getIn(['payload', 'executionDate']);
}
export function getBulkPaymentDate(payment) {
  return isScheduled(payment) ? getUpcomingPaymentDate(payment) : getPastPaymentDate(payment);
}
var pastSuccessfulActivityStatuses = ['ACTIVE', 'SUCCEEDED'];
var pastFailedActivityStatuses = ['CANCELLED', 'FAILED', 'REJECTED'];
var pastActivityStatuses = [].concat(pastSuccessfulActivityStatuses, pastFailedActivityStatuses);
var pastConsentStatuses = ['DECLINED'];
export function setUpcomingFlag(payment) {
  return payment.setIn(['payload', 'upcoming'], isPaymentUpcoming(payment));
}
export function isUpcoming(payment) {
  return payment.getIn(['payload', 'upcoming']);
}
export function isInternational(consent) {
  return consent && consent.getIn(['payload', 'type'], '').indexOf('INTERNATIONAL') > -1;
}
export function isBalanceTransfer(consent) {
  return consent && consent.getIn(['payload', 'type'], '') === 'BALANCE_TRANSFER';
}
export function isDomestic(consent) {
  return !(isInternational(consent) || isBalanceTransfer(consent));
}
export function isScheduled(consent) {
  return consent && consent.getIn(['payload', 'type'], '').indexOf('SCHEDULED') > -1;
}
export function isBulk(consent) {
  return consent && hasChannel('OBPISPBB')(consent);
}
export function sortByActivityDate(a, b) {
  return getPastPaymentDate(b) - getPastPaymentDate(a);
}
export function sortByDueDate(a, b) {
  return getUpcomingPaymentDate(b) - getUpcomingPaymentDate(a);
}
function isPaymentUpcoming(payment) {
  return isBulk(payment) ? isBulkPaymentUpcoming(payment) : isSinglePaymentUpcoming(payment);
}
function isSinglePaymentUpcoming(payment) {
  var activityStatus = payment.getIn(['activity', 'status']);
  var consentStatus = payment.get('status');
  var isUpcoming = pastActivityStatuses.indexOf(activityStatus) === -1 && isScheduled(payment) && pastConsentStatuses.indexOf(consentStatus) === -1;
  return isUpcoming;
}
function isBulkPaymentUpcoming(payment) {
  var activityStatus = payment.getIn(['activity', 'status']);
  var consentStatus = payment.get('status');
  var isUpcoming = pastFailedActivityStatuses.indexOf(activityStatus) === -1 && isScheduled(payment) && pastConsentStatuses.indexOf(consentStatus) === -1 && !moment().isAfter(getUpcomingPaymentDate(payment), 'day');
  return isUpcoming;
}